import PropTypes from 'prop-types';
import React from 'react';

import Card from 'components/Card';
import TextHeader from 'components/TextHeader';
import WizardStep from 'components/Wizard/WizardStep';

/**
 * [DspOptionCard] - simple card for display in the DspConnection page. Displayed as a selectable card
 * or info-only card when no onSelect & value props passed
 */

const DspOptionCard = ({ value, onSelect, selectedValue, testId, title, children }) => (
  <WizardStep.Section>
    <Card
      onClick={value ? () => onSelect(value) : undefined}
      isActive={value ? value === selectedValue : undefined}
      fitHeight
      shadow={false}
      data-testid={testId}
    >
      <Card.Content>
        <TextHeader type={TextHeader.TYPES.MEDIUM}>{title}</TextHeader>
        {children}
      </Card.Content>
    </Card>
  </WizardStep.Section>
);

DspOptionCard.propTypes = {
  children: PropTypes.node,
  onSelect: PropTypes.func,
  selectedValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  testId: PropTypes.string,
  title: PropTypes.string,
  value: PropTypes.string
};

export default DspOptionCard;
